import { XMarkIcon } from "@heroicons/react/20/solid";
import { FilterChipButton } from "./FilterChip.tsx";

const CLEAR_BUTTON_CLASSNAME = "touch-target shrink-0 rounded-l-none border-l-0 px-2 sm:px-2";

export interface FilterChipClearButtonProps {
    ariaLabel: string;
    onClear: () => void;
    isDisabled?: boolean;
}

export function FilterChipClearButton({ ariaLabel, onClear, isDisabled }: FilterChipClearButtonProps) {
    return (
        <FilterChipButton isActive aria-label={ariaLabel} onPress={onClear} isDisabled={isDisabled} className={CLEAR_BUTTON_CLASSNAME}>
            <XMarkIcon aria-hidden="true" className="size-4" />
        </FilterChipButton>
    );
}
